import AppUpdateDetector from "@components/utils/AppUpdateDetector";
import MemberSettingsLoader from "@components/utils/MemberSettingsLoader";
import ThemeColorLoader from "@components/utils/ThemeColorLoader";
import { AppStatsigProvider } from "@configs/statsig/StatsigProvider";
import { ThemePreset } from "@configs/theme-preset";
import * as Sentry from "@sentry/react";
import { store } from "@stores";
import "@styles/App.css";
import { ThemeProvider } from "kz-ui-sdk";
import "kz-ui-sdk/dist/sdk-themes.css";
import React from "react";
import "react-aspect-ratio/aspect-ratio.css";
import { Provider } from "react-redux";
import AppRoutes from "./AppRouter";
import ErrorFallback from "./ErrorFallback";
import "./configs/i18n";

const TestErrorButton = () => {
  const [shouldThrow, setShouldThrow] = React.useState(false);
  if (shouldThrow) {
    throw new Error("Test error for error boundary");
  }
  return (
    <button
      onClick={() => setShouldThrow(true)}
      className="fixed right-10 top-10 z-50 rounded bg-red-500 px-4 py-2 text-white"
    >
      Test Error
    </button>
  );
};

function App() {
  return (
    <ThemeProvider
      value={{
        preset: ThemePreset,
      }}
    >
      <Provider store={store}>
        <ThemeColorLoader />
        <MemberSettingsLoader>
          <AppStatsigProvider>
            <AppRoutes />
          </AppStatsigProvider>
        </MemberSettingsLoader>
        <AppUpdateDetector />
        {localStorage.getItem("SENTRY_DEV_TEST") === "true" && <TestErrorButton />}
      </Provider>
    </ThemeProvider>
  );
}

export const EnhancedApp = Sentry.withErrorBoundary(App, {
  fallback: ({ error, resetError }: { error: unknown; resetError: () => void }) => (
    <ErrorFallback
      error={error}
      resetError={resetError}
    />
  ),
});

export default App;
